import { NgModule } from '@angular/core';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {
  MatCheckboxModule,
  MatListModule,
  MatFormFieldModule,
  MatButtonModule,
  MatSidenavModule,
  MatIconModule,
  MatInputModule,
  MatSliderModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatOptionModule,
  MatSlideToggleModule,
  MatDatepickerModule,
  MatSelectModule,
  MatCardModule,
  MatTabsModule,
  MatExpansionModule,
  MatTooltipModule,
  MatSnackBar,
  MatSnackBarModule
} from '@angular/material';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatListModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatInputModule,
    MatSliderModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatOptionModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCardModule,
    MatTabsModule,
    MatExpansionModule,
    MatTooltipModule,
    MatSnackBarModule
  ],
  exports: [
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatListModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatInputModule,
    MatSliderModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatOptionModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCardModule,
    MatTabsModule,
    MatExpansionModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatSnackBarModule
  ]
})

export class MaterialModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/material/material.module.ts